import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCLogger } from "../../../../js/lib/logger";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";

export const HostSystemClientManager = (function() {

	var restUrl = "hostSystem/";

	var supportedFunctionality = {};

	const getSupportedFunctionalityEvent = LS2PAC_CONSTANTS.Events.onGetSupportFunctionality;

	TLCEventManager.addListener(getSupportedFunctionalityEvent, function() {
		getSupportFunctionality();
	});

	var getSupportFunctionality = function() {
		TLCRest.jsonCall(restUrl+"supportedFunctionality", {
			callback: function(data) {
				supportedFunctionality = data;
				TLCLogger.log("supportedFunctionality", supportedFunctionality);
				TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onGetSupportFunctionalityResponse, {success: true, data: supportedFunctionality});
			}
		});
	};

	return {
		getSupportFunctionality: function() {
			return supportedFunctionality;
		},
		getSupportedFunctionalityEvent: getSupportedFunctionalityEvent
	};

})();
